import React from "react";
import { Container } from "semantic-ui-react";
import CampaniaList from "./CampaniaList";
import PropTypes from "prop-types";
import CampaniasHeader from "./CampaniaHeader";
import CampaniaListEmpty from "./CampaniaListEmpty";

const CampaniaDashboard = ({ campanias }) => {
  return (
    <Container className="containerPrincipal">
      <CampaniasHeader />
      {campanias && campanias.length === 0 ? (
        <CampaniaListEmpty />
      ) : (
        <CampaniaList campanias={campanias} />
      )}
      <br/>
    </Container>
  );
};

CampaniaDashboard.propTypes = {
  campanias: PropTypes.array.isRequired,
};
export default CampaniaDashboard;
